import { convenioService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const convenioAction = {
    getConvenio,
    getConvenioById,
    onChangeProps,
    editConvenioInfo,
    createConvenio,
    deleteConvenioById,
};
function getConvenio(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'convenios';
        convenioService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeConveniosList(response.data));
                if (showWaiting) {
                    alerts.clean();
                   // console.log("resp", response.data)
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}
function createConvenio(payload) {
    return dispatch => {
        let apiEndpoint = 'convenios/';
        convenioService.post(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createConvenioInfo());
                    alerts.success(ret.message, ret.Path);
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}


function getConvenioById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'convenios/' + id;
        convenioService.get(apiEndpoint)
            .then((response) => {
             //   console.log("respp", response.data)
                dispatch(editConveniosDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    };
}
function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}

function editConvenioInfo(id, payload) {
    return dispatch => {
        let apiEndpoint = 'convenios/' + id;
        convenioService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                   // console.log("response", response)
                    dispatch(updatedConvenioInfo());
                    alerts.success(ret.message, '/convenios'); //ret.Path
                } else {
                    alerts.warning(response.data.Message);
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    }
}
function deleteConvenioById(id) {
    return dispatch => {

        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {

                    let apiEndpoint = 'convenios/' + id;
                    convenioService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteConveniosDetails());
                                dispatch(convenioAction.getConvenio());
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })

                }
            });


    };
}
export function changeConveniosList(convenio) {
    return {
        type: "FETECHED_ALL_CONVENIO",
        convenio: convenio
    }
}

export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editConveniosDetails(convenio) {
   
    return {
        type: "CONVENIO_DETAIL",
        id: convenio.id,
        nome: convenio.nome,
        cnpj: convenio.cnpj,
        endereco: convenio.endereco,
        id_usuario: convenio.id_usuario
    }
}
export function updatedConvenioInfo() {
    return {
        type: "CONVENIO_UPDATED"
    }
}
export function createConvenioInfo() {
    return {
        type: "CONVENIO_CREATED_SUCCESSFULLY"
    }
}
export function deleteConveniosDetails() {
    return {
        type: "DELETED_CONVENIO_DETAILS"
    }
}